import React, { useState } from 'react';
import {
  Bot, Sparkles, Check, ShieldCheck, Gift, Headphones, UserPlus, Link2, Rocket, Loader2, Crown, MessageCircle, CheckCircle2,
} from 'lucide-react';
import { API_URL } from '../../config';
import AgentOffer, { useAgentOffer } from './AgentOffer';

// ============================================================
// CHOIX DE L'OFFRE FACEBOOK (client) — deux formules, présentées en cartes 3D :
//   1. « Messenger Bot » : l'agent IA répond aux messages de la Page. Le client connecte sa Page lui-même avec Facebook.
//   2. « Messenger Bot + Community Manager Studio » : en plus, CM Studio (publications IA, suivi des commentaires, réponses publiques).
//      Mise en place PAR L'ÉQUIPE : le client nous écrit dans Support, ajoute le compte indiqué comme administrateur partiel de sa Page,
//      puis nous connectons la Page et configurons l'agent. (En attendant la validation Meta de l'App Review.)
// Exporte aussi CmSetupCard (client qui a payé l'offre CM : étapes de mise en place) et CmPromoCard (invitation à passer à l'offre CM).
// ============================================================

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('auth_token')}`, 'Content-Type': 'application/json' });
const fmtAr = (n) => `${Math.round(n || 0).toLocaleString('fr-FR')} Ar`.replace(/[  ]/g, ' ');

const CSS = `
.fp-scene { perspective:1400px; }
.fp-card { position:relative; border-radius:30px; padding:26px 22px 22px; overflow:hidden; text-align:left; transform-style:preserve-3d; cursor:pointer;
  background:linear-gradient(155deg,rgba(255,255,255,.12),rgba(255,255,255,.025)); border:1px solid rgba(255,255,255,.18);
  box-shadow:0 36px 70px rgba(0,0,0,.5), inset 0 1px 0 rgba(255,255,255,.3); transition:transform .35s, box-shadow .35s, border-color .35s; transform:rotateX(3deg) rotateY(var(--ry,0deg)); }
.fp-card:hover { transform:rotateX(0) rotateY(0) translateY(-6px); box-shadow:0 50px 90px rgba(0,0,0,.6), inset 0 1px 0 rgba(255,255,255,.35); }
.fp-card.on { border-color:var(--a); box-shadow:0 0 0 2px var(--a), 0 50px 90px rgba(0,0,0,.6), 0 0 60px color-mix(in srgb, var(--a) 35%, transparent); }
.fp-glow { position:absolute; width:300px; height:300px; right:-120px; top:-130px; border-radius:50%; filter:blur(60px); opacity:.38; pointer-events:none; background:var(--a); }
.fp-tile { width:60px; height:60px; border-radius:20px; display:flex; align-items:center; justify-content:center; color:#fff; flex:none;
  background:linear-gradient(145deg,var(--a),var(--b)); box-shadow:0 18px 30px rgba(0,0,0,.45), inset 0 2px 0 rgba(255,255,255,.4), inset 0 -5px 0 rgba(0,0,0,.22); animation:fpBob 5s ease-in-out infinite; }
@keyframes fpBob { 0%,100%{transform:translateY(0) rotateY(-8deg)} 50%{transform:translateY(-7px) rotateY(8deg)} }
.fp-price { font-family:'Space Grotesk','DM Sans',sans-serif; font-weight:800; color:#fff; font-size:clamp(34px,6.5vw,46px); line-height:1;
  text-shadow:1px 1px 0 #3b2fb0,2px 2px 0 #3b2fb0,3px 3px 0 #342aa0,4px 4px 0 #342aa0,5px 5px 0 #2d2590,8px 12px 20px rgba(0,0,0,.5); }
.fp-ribbon { display:inline-flex; align-items:center; gap:6px; margin-bottom:14px; padding:5px 12px; border-radius:999px; font-size:11px; font-weight:800; letter-spacing:.08em; color:#fff;
  background:linear-gradient(90deg,#f59e0b,#ef4444); box-shadow:0 8px 18px rgba(0,0,0,.4), inset 0 1px 0 rgba(255,255,255,.35); }
.fp-li { display:flex; gap:9px; align-items:flex-start; font-size:13.5px; color:#e8ecff; line-height:1.35; }
.fp-li .ck { flex:none; width:20px; height:20px; border-radius:7px; display:flex; align-items:center; justify-content:center; margin-top:1px;
  background:linear-gradient(145deg,#86efac,#22c55e); color:#052e1a; box-shadow:0 3px 0 #15803d; }
.fp-btn { display:inline-flex; align-items:center; justify-content:center; gap:9px; padding:13px 22px; border-radius:16px; font-weight:800; font-size:14.5px; color:#fff; border:0; cursor:pointer; width:100%;
  background:linear-gradient(135deg,var(--a),var(--b)); box-shadow:0 6px 0 rgba(0,0,0,.35), 0 18px 30px rgba(0,0,0,.35); transition:transform .15s, box-shadow .15s; }
.fp-btn:active { transform:translateY(3px); box-shadow:0 3px 0 rgba(0,0,0,.35), 0 10px 20px rgba(0,0,0,.3); }
.fp-btn:disabled { opacity:.6; cursor:not-allowed; }
.fp-btn.ghost { background:rgba(255,255,255,.1); box-shadow:0 6px 0 rgba(0,0,0,.28); border:1px solid rgba(255,255,255,.2); }
.fp-steps { position:relative; display:grid; gap:14px; }
.fp-steps::before { content:''; position:absolute; left:19px; top:18px; bottom:18px; width:3px; border-radius:2px; background:linear-gradient(180deg,var(--a),rgba(255,255,255,.12)); }
.fp-step { position:relative; display:flex; gap:14px; align-items:flex-start; }
.fp-num { position:relative; z-index:1; width:40px; height:40px; border-radius:14px; flex:none; display:flex; align-items:center; justify-content:center; color:#fff; font-weight:800;
  background:linear-gradient(145deg,var(--a),var(--b)); box-shadow:0 6px 0 rgba(0,0,0,.35), 0 14px 22px rgba(0,0,0,.35); }
@media (prefers-reduced-motion: reduce) { .fp-card, .fp-tile, .fp-btn { animation:none; transition:none; } }
`;

const BOT_FEATURES = [
  'Agent IA Messenger 24h/24, en français et en malgache',
  'Détection des ventes + fiche client créée automatiquement',
  'Alertes Telegram et notifications dans l\'application',
  'Conversations, ventes et statistiques dans votre espace',
  'Mise en place et configuration par l\'équipe TeckiA',
];
const CM_FEATURES = [
  'Tout ce que contient « Messenger Bot »',
  'Community Manager Studio : publications IA (texte + visuels) et programmation',
  'Suivi de vos publications et de leurs commentaires',
  'Réponses publiques automatiques aux commentaires',
  'Mise en place complète par notre équipe',
];

function PlanCard({ id, active, onPick, accent, icon: Icon, title, tagline, price, features, ribbon, cta, tilt }) {
  return (
    <div className={`fp-card ${active ? 'on' : ''}`} style={{ '--a': accent[0], '--b': accent[1], '--ry': tilt }} onClick={() => onPick(id)} role="button" tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onPick(id); }}>
      <div className="fp-glow" />
      <div className="relative">
        {ribbon && <div className="fp-ribbon">⭐ {ribbon}</div>}
        <div className="flex items-center gap-3">
          <div className="fp-tile"><Icon className="w-7 h-7" /></div>
          <div className="min-w-0">
            <div className="text-white font-extrabold text-lg leading-tight">{title}</div>
            <div className="text-xs text-indigo-100/75 mt-0.5">{tagline}</div>
          </div>
        </div>
        <div className="mt-5 flex items-end gap-2">
          <span className="fp-price">{fmtAr(price)}</span>
          <span className="text-blue-100 font-bold pb-1 text-sm">par Page · par mois</span>
        </div>
        <ul className="mt-5 grid gap-2.5">
          {features.map(f => <li key={f} className="fp-li"><span className="ck"><Check className="w-3.5 h-3.5" strokeWidth={3} /></span>{f}</li>)}
        </ul>
        <button type="button" className="fp-btn mt-6" onClick={(e) => { e.stopPropagation(); onPick(id); }}>{cta}</button>
      </div>
    </div>
  );
}

// ------------------------------------------------------------ étapes de la mise en place par l'équipe (offre CM)
function CmSteps({ accent }) {
  const steps = [
    { icon: ShieldCheck, t: 'Vous réglez l\'abonnement', d: 'MVola, Orange Money ou carte bancaire.' },
    { icon: Headphones, t: 'Vous nous écrivez dans « Support »', d: 'Nous vous indiquons le compte à ajouter à votre Page.' },
    { icon: UserPlus, t: 'Vous ajoutez ce compte comme administrateur partiel', d: 'Contenu, Messages et appels, Activité de la communauté, Statistiques (2 minutes dans les paramètres de votre Page).' },
    { icon: Link2, t: 'Nous connectons votre Page et configurons votre agent', d: 'Agent Messenger et Community Manager Studio sont prêts à l\'emploi.' },
    { icon: Rocket, t: 'Vous êtes prévenu dans l\'application', d: 'Et vous pouvez demander à gérer vous-même votre agent.' },
  ];
  return (
    <div className="fp-steps" style={{ '--a': accent[0], '--b': accent[1] }}>
      {steps.map((s, i) => (
        <div className="fp-step" key={i}>
          <div className="fp-num"><s.icon className="w-5 h-5" /></div>
          <div className="pt-0.5">
            <div className="text-white font-bold text-sm">{i + 1}. {s.t}</div>
            <div className="text-xs text-indigo-100/70 mt-0.5 leading-snug">{s.d}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

const BOT = ['#2563eb', '#6366f1'];
const CM = ['#f97316', '#ec4899'];

export default function FacebookPlans({ meBot, reloadBot, onSupport, initialPlan = '' }) {
  const [plan, setPlan] = useState(initialPlan);
  const [showPay, setShowPay] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const { me: meCm, reload: reloadCm } = useAgentOffer('facebook_cm');
  const botPrice = meBot?.price_ar || meBot?.bot_price_ar || 80000;
  const cmPrice = meCm?.price_ar || meBot?.cm_price_ar || 150000;

  const contactSupport = async () => {
    setSending(true); setError('');
    try {
      const res = await fetch(`${API_URL}/api/agent-offers/cm-interest`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({}) });
      const d = await res.json();
      if (!d.success) throw new Error(d.message || 'Envoi impossible.');
      setSent(true);
      if (onSupport) setTimeout(onSupport, 500);
    } catch (e) { setError(e.message || 'Envoi impossible. Réessayez.'); } finally { setSending(false); }
  };

  return (
    <div className="mb-10">
      <style>{CSS}</style>
      <div className="text-center mb-7">
        <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/10 border border-white/15 text-xs font-bold tracking-widest uppercase text-indigo-100"><Crown className="w-3.5 h-3.5" /> Nos offres Facebook</div>
        <h2 className="text-2xl md:text-3xl font-extrabold text-white mt-3">Choisissez la formule de votre Page</h2>
        <p className="text-sm text-indigo-100/75 mt-1.5">Sans engagement · vous payez mois par mois · une offre par Page</p>
      </div>

      <div className="fp-scene grid gap-6 md:grid-cols-2">
        <PlanCard id="bot" active={plan === 'bot'} onPick={(p) => { setPlan(p); setShowPay(false); }} accent={BOT} icon={Bot} tilt="3deg"
          title="Messenger Bot" tagline="Votre agent répond à vos clients, jour et nuit" price={botPrice} features={BOT_FEATURES}
          cta={meBot?.trial_available ? <><Gift className="w-5 h-5" /> 7 jours gratuits pour essayer</> : <><Bot className="w-5 h-5" /> Choisir Messenger Bot</>} />
        <PlanCard id="cm" active={plan === 'cm'} onPick={(p) => { setPlan(p); setShowPay(false); }} accent={CM} icon={Sparkles} tilt="-3deg" ribbon="LE PLUS COMPLET"
          title="Messenger Bot + Community Manager Studio" tagline="Votre agent + vos publications et commentaires gérés" price={cmPrice} features={CM_FEATURES}
          cta={<><Sparkles className="w-5 h-5" /> Choisir cette offre</>} />
      </div>

      {plan === 'bot' && (
        <div className="mt-8">
          <AgentOffer channel="facebook" me={meBot} reload={reloadBot} show="gate" />
        </div>
      )}

      {plan === 'cm' && (
        <div className="mt-8 fp-scene">
          <div className="fp-card" style={{ '--a': CM[0], '--b': CM[1], cursor: 'default', transform: 'rotateX(2deg)' }}>
            <div className="fp-glow" />
            <div className="relative">
              <h3 className="text-white font-extrabold text-xl flex items-center gap-2"><Sparkles className="w-5 h-5 text-amber-300" /> Comment ça se passe ?</h3>
              <p className="text-sm text-indigo-100/75 mt-1 mb-5">Pour cette offre, c'est notre équipe qui met tout en place sur votre Page : vous n'avez rien de technique à faire.</p>
              <CmSteps accent={CM} />
              <div className="mt-6 grid gap-3 sm:grid-cols-2">
                <button className="fp-btn" style={{ '--a': CM[0], '--b': CM[1] }} onClick={() => setShowPay(v => !v)}><ShieldCheck className="w-5 h-5" /> {showPay ? 'Masquer le paiement' : `Payer l'abonnement · ${fmtAr(cmPrice)}/mois`}</button>
                <button className="fp-btn ghost" onClick={contactSupport} disabled={sending || sent}>
                  {sending ? <Loader2 className="w-5 h-5 animate-spin" /> : sent ? <CheckCircle2 className="w-5 h-5 text-emerald-300" /> : <MessageCircle className="w-5 h-5" />}
                  {sent ? 'Message envoyé à l\'équipe' : 'Écrire au support pour commencer'}
                </button>
              </div>
              {error && <p className="text-sm text-rose-300 mt-3">{error}</p>}
              <p className="text-xs text-indigo-100/60 mt-4 text-center">Le compte à ajouter à votre Page vous est indiqué par l'équipe dans le Support, jamais publiquement.</p>
            </div>
          </div>
          {showPay && meCm && <div className="mt-6"><AgentOffer channel="facebook_cm" me={meCm} reload={() => { reloadCm(); reloadBot && reloadBot(); }} show="gate" /></div>}
        </div>
      )}
    </div>
  );
}

// ------------------------------------------------------------ client qui a l'offre CM : la mise en place par l'équipe est en cours
export function CmSetupCard({ onSupport }) {
  return (
    <div className="mb-8 fp-scene">
      <style>{CSS}</style>
      <div className="fp-card" style={{ '--a': CM[0], '--b': CM[1], cursor: 'default', transform: 'rotateX(2deg)' }}>
        <div className="fp-glow" />
        <div className="relative">
          <div className="flex items-center gap-3 mb-1">
            <div className="fp-tile"><Sparkles className="w-7 h-7" /></div>
            <div>
              <div className="text-white font-extrabold text-lg">Votre offre « Messenger Bot + CM Studio » est active ✅</div>
              <div className="text-xs text-indigo-100/75">Il reste la mise en place sur votre Page, faite par notre équipe.</div>
            </div>
          </div>
          <div className="mt-5"><CmSteps accent={CM} /></div>
          {onSupport && <div className="mt-5"><button className="fp-btn" style={{ '--a': CM[0], '--b': CM[1] }} onClick={onSupport}><Headphones className="w-5 h-5" /> Écrire à l'équipe dans Support</button></div>}
        </div>
      </div>
    </div>
  );
}

// ------------------------------------------------------------ client « Messenger Bot » : invitation à passer à l'offre CM
export function CmPromoCard({ onOpen }) {
  return (
    <div className="mb-8 fp-scene">
      <style>{CSS}</style>
      <div className="fp-card" style={{ '--a': CM[0], '--b': CM[1], transform: 'rotateX(2deg)', padding: '18px 20px' }} onClick={onOpen}>
        <div className="fp-glow" />
        <div className="relative flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="fp-tile" style={{ width: 52, height: 52 }}><Sparkles className="w-6 h-6" /></div>
          <div className="flex-1 min-w-0">
            <div className="text-white font-extrabold">Ajoutez Community Manager Studio</div>
            <div className="text-xs text-indigo-100/75 mt-0.5">Publications IA, suivi des commentaires et réponses publiques automatiques, mis en place par notre équipe.</div>
          </div>
          <button type="button" className="fp-btn sm:w-auto" style={{ '--a': CM[0], '--b': CM[1], width: 'auto', padding: '11px 18px' }} onClick={(e) => { e.stopPropagation(); onOpen(); }}>Découvrir l'offre</button>
        </div>
      </div>
    </div>
  );
}
